var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.84 4.36082C15.9957 4.20512 16.2069 4.11764 16.4271 4.11764C16.5361 4.11764 16.6441 4.13912 16.7448 4.18084C16.8456 4.22257 16.9371 4.28372 17.0142 4.36082C17.0913 4.43792 17.1525 4.52945 17.1942 4.63018C17.2359 4.73091 17.2574 4.83888 17.2574 4.94791C17.2574 5.05694 17.2359 5.1649 17.1942 5.26564C17.1525 5.36637 17.0913 5.4579 17.0142 5.535L6.78115 15.768L5.21558 16.1594L5.60698 14.5939L15.84 4.36082ZM16.4271 2.24264C15.7096 2.24264 15.0215 2.52766 14.5142 3.035L4.09753 13.4517C3.97739 13.5718 3.89215 13.7224 3.85094 13.8872L3.0176 17.2205C2.93774 17.54 3.03134 17.878 3.2642 18.1108C3.49706 18.3437 3.83501 18.4373 4.15449 18.3574L7.48782 17.5241C7.65267 17.4829 7.80321 17.3976 7.92336 17.2775L18.34 6.86082C18.5912 6.60961 18.7905 6.31139 18.9265 5.98317C19.0624 5.65495 19.1324 5.30317 19.1324 4.94791C19.1324 4.59265 19.0624 4.24087 18.9265 3.91265C18.7905 3.58443 18.5912 3.2862 18.34 3.035C18.0888 2.78379 17.7906 2.58452 17.4624 2.44857C17.1342 2.31262 16.7824 2.24264 16.4271 2.24264ZM11.4271 16.5104C10.9093 16.5104 10.4896 16.9301 10.4896 17.4479C10.4896 17.9657 10.9093 18.3854 11.4271 18.3854H18.9271C19.4449 18.3854 19.8646 17.9657 19.8646 17.4479C19.8646 16.9301 19.4449 16.5104 18.9271 16.5104H11.4271Z",
    fill: "#98C804"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.b7e3a2fa880e2444cb89c9a91fa619be.svg";
export { ForwardRef as ReactComponent };